import { combineReducers } from "redux";
import templateNotificationsReducer from "./template/reducer";
import systemNotificationsReducer from "./system/reducer";
import systemAdminNotificationsReducer from "./systemAdmin/reducer";

export type NotificationsSlice = {
  template: ReturnType<typeof templateNotificationsReducer>;
  system: ReturnType<typeof systemNotificationsReducer>;
  systemAdmin: ReturnType<typeof systemAdminNotificationsReducer>;
};

export const notificationsReducer = combineReducers<NotificationsSlice>({
  template: templateNotificationsReducer,
  system: systemNotificationsReducer,
  systemAdmin: systemAdminNotificationsReducer,
});

export default notificationsReducer;
